export default __webpack_public_path__ + "static/media/concertina.710985ec.png";